/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiBaseService } from '../dapi-base-service';
import { DapiHttpResponse } from '../dapi-http-response';
import { DapiRequestBuilder } from '../dapi-request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FinnairAirBoundsChangeRequest } from '../models/finnair-air-bounds-change-request';
import { FinnairAirBoundsChangeResponse } from '../models/finnair-air-bounds-change-response';
import { FinnairAirCalendarChangeListResponse } from '../models/finnair-air-calendar-change-list-response';
import { FinnairCalendarChangeRequest } from '../models/finnair-calendar-change-request';


/**
 * Offer change api resource
 */
@Injectable({
  providedIn: 'root',
})
export class OffersChangesService extends DapiBaseService {
  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  /**
   * Path part for operation findAirBoundsChange
   */
  static readonly FindAirBoundsChangePath = '/api/change/{orderId}/airBounds';

  /**
   * findAirBoundChange.
   *
   * Returns the offers for the PNR and requested bound given
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAirBoundsChange()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findAirBoundsChange$Response(rootUrl: string, params: {
    orderId: string;
    hash?: string;
    locale?: string;
    body: FinnairAirBoundsChangeRequest
  }): Observable<DapiHttpResponse<FinnairAirBoundsChangeResponse>> {
    const rb = new DapiRequestBuilder(rootUrl, OffersChangesService.FindAirBoundsChangePath, 'post');

    if (params) {
      rb.path('orderId', params.orderId, {});
      rb.query('hash', params.hash, {});
      rb.query('locale', params.locale, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DapiHttpResponse<FinnairAirBoundsChangeResponse>;
      }),
      catchErrorAsJson()
    );
  }

  /**
   * findAirBoundChange.
   *
   * Returns the offers for the PNR and requested bound given
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAirBoundsChange$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findAirBoundsChange(rootUrl: string, params: {
    orderId: string;
    hash?: string;
    locale?: string;
    body: FinnairAirBoundsChangeRequest
  }): Observable<FinnairAirBoundsChangeResponse> {
    return this.findAirBoundsChange$Response(rootUrl, params).pipe(
      map((r: DapiHttpResponse<FinnairAirBoundsChangeResponse>) => r.body as FinnairAirBoundsChangeResponse)
    );
  }

  /**
   * Path part for operation findAirCalendarChange
   */
  static readonly FindAirCalendarChangePath = '/api/change/{orderId}/calendar';

  /**
   * findAirCalendarChange.
   *
   * Returns the calendar matrix for the PNR and request given
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAirCalendarChange()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findAirCalendarChange$Response(rootUrl: string, params: {
    orderId: string;
    hash?: string;
    locale?: string;
    body: FinnairCalendarChangeRequest
  }): Observable<DapiHttpResponse<FinnairAirCalendarChangeListResponse>> {
    const rb = new DapiRequestBuilder(rootUrl, OffersChangesService.FindAirCalendarChangePath, 'post');

    if (params) {
      rb.path('orderId', params.orderId, {});
      rb.query('hash', params.hash, {});
      rb.query('locale', params.locale, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DapiHttpResponse<FinnairAirCalendarChangeListResponse>;
      }),
      catchErrorAsJson()
    );
  }

  /**
   * findAirCalendarChange.
   *
   * Returns the calendar matrix for the PNR and request given
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAirCalendarChange$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findAirCalendarChange(rootUrl: string, params: {
    orderId: string;
    hash?: string;
    locale?: string;
    body: FinnairCalendarChangeRequest
  }): Observable<FinnairAirCalendarChangeListResponse> {
    return this.findAirCalendarChange$Response(rootUrl, params).pipe(
      map((r: DapiHttpResponse<FinnairAirCalendarChangeListResponse>) => r.body as FinnairAirCalendarChangeListResponse)
    );
  }

}
